import { Guid } from 'guid-typescript';
import { ThirdPartyTracingActionExpiration } from './thridparty-tracingaction-expiration';
import { FollowUpResponseEnum, FollowUpThirdPartyResponseEnum } from './tracing-plan-task-item';

export class ThirdPartyTracingActionListItem {
    id: number | Guid = 0;
    description: string = '';
    active: boolean = true;
    activeReviewed?: boolean = true;
    expirationDate?: Date = new Date();
    expirationType?: ThirdPartyTracingActionExpiration;
    custom: boolean = false;
    idFromFollowUpTaskAppFormAnswer?: number = 0;
    idFromMaster?: number = 0;
    idFromOptional?: number = 0;
    rebuiltExpirationDate? = true;
    idFromPreviousTask?;
    canBeReUsed: boolean;
    reUseTask? = true;
    iterativeTasks? = [];

    followUpResponseEnum?: FollowUpResponseEnum;
    followUpThirdPartyResponseEnum?: FollowUpThirdPartyResponseEnum;

    roleId: number = 0;
    roleDescription: string = '';

    constructor() {
    }
}